// extracted by css-extract-rspack-plugin
export default {"switchRoot":"hwtbAv","switchThumb":"FAQcWv"};